import React, { useState } from 'react';

import { DefaultButton, TooltipHost, ContextualMenuItemType, makeStyles } from '@fluentui/react';

import LockedFeatureCallout from 'src/components/base/LockedFeatureCallout';
import TeachingCoachmark from 'src/components/base/TeachingCoachmark';
import { useIdAsTarget } from 'shared/hooks';


const WH = '24px';

const iconStyle = (palette) => ({
  color: palette.themePrimary,
  margin: '0px',
  padding: '0px',
  width: WH,
  height: WH,
  lineHeight: WH,
  selectors: {
    ':hover': {
      color: palette.themePrimary,
    },
  }
});

const useCustomStyles = makeStyles(({ palette }) => ({
  commandIcon: {...iconStyle(palette), fontSize: WH },
  commandIconLarge: {...iconStyle(palette), fontSize: '16px' },
  commandIconPlaceholder: {
    width: '32px',
    height: '32px',
  },
  commandsContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0px 16px 4px 16px',
    margin: '8px 0px',
    borderBottom: '1px solid #00000029',
  },
}));


export const CommandIcon = ({ text, tooltip, iconName, menuItems, licensing, teaching, onClick, isLarge = false, ...otherProps }) => {
  const classNames = useCustomStyles();
  const [buttonId, target] = useIdAsTarget('button');
  const [calloutOpenState, setCalloutOpenState] = useState(false);

  const toggleCallout = () => setCalloutOpenState(!calloutOpenState);
  const size = isLarge ? 40 : 32;

  const { can = true, plans } = licensing || {};
  const handleClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    !can
      ? toggleCallout()
      : !!onClick && onClick(e);
  }

  return (
    <>
      <TooltipHost content={tooltip}>
        <DefaultButton
          id={buttonId}
          iconProps={{ iconName, styles: { root: isLarge ? classNames.commandIconLarge : classNames.commandIcon } }}
          calloutProps={{ gapSpace: 0 }} styles={{ root: { display: 'inline-block'  }}}
          text={text}
          onClick={handleClick}
          styles={{
            root: { minWidth: size, minHeight: size, height: size, padding: '0px 4px', border: '0px', backgroundColor: 'rgba(255,255,255,0)' },
            rootHovered: { backgroundColor: '#f3f2f1' },
          }}
          menuProps={ !onClick && !!menuItems.length
            ? { items: menuItems.map((x, index) => !!x ? x : { key: `divider_${index}`, itemType: ContextualMenuItemType.Divider }) }
            : null}
          { ...otherProps }
        />
      </TooltipHost>
      { teaching && <TeachingCoachmark target={target} {...teaching} /> }
      { !can && calloutOpenState && <LockedFeatureCallout target={target} plans={plans} onDismiss={toggleCallout}/> }
    </>
  )
}


export const CommandIconPlaceholder = ({}) => {
  const classNames = useCustomStyles();
  return (<div className={classNames.commandIconPlaceholder}></div>);
}


export function CommandsBar({ leftItems = [], rightItems = [] }) {
  const classNames = useCustomStyles();

  function Bar({ className, items }) {
    return (
      <div className={className}>
        { items.map((x, index) => x
          ? <CommandIcon key={index} { ...x} />
          : <CommandIconPlaceholder key={index}/>) 
        }
      </div>
    );
  }
  return (
    <div className={classNames.commandsContainer}>
      <Bar className={'leftBar'} items={leftItems} />
      <Bar className={'rightBar'} items={rightItems} />
    </div>
  );
}



export default CommandIcon;